import React, { useState } from 'react';
import './Card.css'

function Card() {
    const [figure, setFigure] = useState(3429);
    const [coins, setCoins] = useState(0.041)
  return (
      <div className='container'>
      <div className='card'>
          <div className='equilibrium'>
          <img src='./images/image-equilibrium.jpg' alt='' className='eq'/>
          <div className='overlay overlayLeft'>
              <div className='text'><img src='./images/icon-view.svg' alt='' /></div>
          </div>
          </div>
          <h2>Equilibrium #{figure}</h2>
          <p className='desc'>
              Our Equilibrium collection promotes balance and calm.
          </p>
          <div className='c-t'>
              <div className='coins'>
                <img src='./images/icon-ethereum.svg' alt='' />
                <h3>{coins} ETH</h3>
              </div>

              <div className='time'>
                  <img src='./images/icon-clock.svg' alt='' />
                  <h3>3 days left</h3>
              </div>

          </div>
          <footer>
              <img  src='./images/image-avatar.png' alt=''/>
              <p>Creation of <span>Jules Wyvern</span></p>
          </footer>
      </div>
      </div>
  );
}

export default Card;
